import { Card, Group, Image, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const StiSectionThree = () => {
	return (
		<section className={'bg-secondary'}>
			<TwContainer className={'justify-center py-16 pt-32'} column>
				<Title variant={'title'}>Our STI and STD Services</Title>
				<Group mt={'xl'} justify={'center'} align={'stretch'} gap={48}>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_34.webp'} w={50} h={56} alt={'STI and STD Testing'} />
						<Title variant={'subtitle'} fz={24}>
							STI and STD Testing
						</Title>
						<Text variant={'gray'}>
							We offer a wide range of STI and STD tests, including screenings for common infections such as chlamydia, gonorrhea, syphilis, and more.
							Our testing is conducted with precision and care to ensure accuracy.
						</Text>
					</Card>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_35.webp'} w={42} h={67.2} alt={'STI and STD Counseling'} />
						<Title variant={'subtitle'} fz={24}>
							STI and STD Counseling
						</Title>
						<Text variant={'gray'}>
							Our team of dedicated counselors is available to provide emotional support, answer your questions, and offer guidance before and after
							testing. Your peace of mind matters to us.
						</Text>
					</Card>
					<Card
						style={{
							boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
						}}
						className={' flex-col flex gap-2 justify-center max-w-xs  p-6 items-center py-12'}
						radius={20}
					>
						<Image loading={'lazy'} src={'/images/img_36.webp'} w={50} h={55} alt={'Treatment and Referrals'} />
						<Title variant={'subtitle'} fz={24}>
							Treatment and Referrals
						</Title>
						<Text variant={'gray'}>
							If you receive a positive diagnosis, our clinic can provide treatment options or refer you to specialists who can provide the care you
							need.
						</Text>
					</Card>
				</Group>
			</TwContainer>
		</section>
	)
}
